import { useEffect, useRef, useState } from "react";
import gsap from "gsap";

type Props = {
  imgs: Array<string> | undefined;
  open: boolean;
  setClose: Function;
};

const Overlay = ({ imgs, open, setClose }: Props) => {
  const [currentIndex, setcurrentIndex] = useState<number>(0);

  useEffect(() => {
    handleOpenOverlay(open);
  }, [open]);

  const handleOpenOverlay = (open: boolean) => {
    if (open) {
      gsap.fromTo("#overlay", { opacity: 0, duration: 2 }, { opacity: 1 });
      gsap.fromTo(".stag", { opacity: 0 }, { opacity: 1, stagger: 0.1 });
    }
  };

  const nextSlide = () => {
    if (imgs && currentIndex + 1 === imgs?.length) {
      setcurrentIndex(0);
    } else setcurrentIndex(currentIndex + 1);
  };

  const prevSlide = () => {
    if (currentIndex === 0) {
      setcurrentIndex(imgs ? imgs?.length - 1 : 0);
    } else setcurrentIndex(currentIndex - 1);
  };

  const exitOverlay = async () => {
    gsap.to(".stag", {
      opacity: 0,
      stagger: 0.1,
      onComplete: () => {
        gsap.to("#overlay", {
          opacity: 0,
          onComplete: () => setClose(false),
        });
      },
    });
  };

  const applyBrightnessEffect = (element: string, callback: () => void) => {
    const tl = gsap.timeline({
      onComplete: () => {
        callback();
      },
    });

    tl.to(element, {
      filter: "brightness(1.8)",
      duration: 0.15,
      ease: "power2.out",
    }).to(element, {
      filter: "brightness(1)",
      duration: 0.15,
      ease: "power2.in",
    });
  };

  return (
    <>
      {open ? (
        <div
          id="overlay"
          className="absolute w-screen h-screen z-40 flex justify-center bg-black bg-opacity-75"
        >
          {imgs && imgs?.length > 1 && (
            <div className="flex justify-center items-center w-[10%] h-full stag">
              {currentIndex > 0 && (
                <button
                  className="h-48 w-44 flex justify-center items-center slider_left"
                  onClick={() =>
                    applyBrightnessEffect(".slider_left", prevSlide)
                  }
                >
                  <img src="/assets/slide_l.svg" alt="slide left" />
                </button>
              )}
            </div>
          )}
          <div className="w-4/5 flex relative stag">
            <button
              className="h-1/3 w-1/3 bg-transparent absolute right-0 top-16 z-50 stag"
              onClick={() => exitOverlay()}
            ></button>
            <div className="overflow-hidden h-fit w-fit flex justify-center items-center m-auto video_container">
              {imgs && <img src={imgs[currentIndex]} alt="slide" />}
            </div>
          </div>
          {imgs && imgs?.length > 1 && (
            <div className="flex justify-center items-center w-[10%] h-ful stag">
              {currentIndex < imgs?.length - 1 && (
                <button
                  className="h-48 w-44  flex justify-center items-center slider_right"
                  onClick={() => {
                    applyBrightnessEffect(".slider_right", nextSlide);
                  }}
                >
                  <img src="/assets/slide_r.svg" alt="slide right" />
                </button>
              )}
            </div>
          )}
        </div>
      ) : null}
    </>
  );
};

export default Overlay;
